import { render, staticRenderFns } from "./QuestionsPage.vue?vue&type=template&id=651133b1&"
import script from "./QuestionsPage.vue?vue&type=script&lang=js&"
export * from "./QuestionsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports